const normalizeThreadItems = ({ threads = null, fallbackThreadMetaById = null } = {}) => {
  if (Array.isArray(threads)) {
    return threads;
  }

  const threadEntries = threads && typeof threads === 'object' ? Object.entries(threads) : Object.entries(fallbackThreadMetaById || {});

  return threadEntries
    .map(([threadId, threadMeta]) => {
      const normalizedThreadId = String(threadMeta?.id || threadMeta?.threadId || threadId || '').trim();

      if (!normalizedThreadId) {
        return null;
      }

      if (threadMeta?.id === normalizedThreadId || threadMeta?.threadId === normalizedThreadId) {
        return threadMeta;
      }

      return {
        ...threadMeta,
        id: normalizedThreadId
      };
    })
    .filter(Boolean);
};

export default normalizeThreadItems;
